import { create } from 'zustand';

/**
 * Open/close state of the "Rechercher un dossier" modal (mahhp 22861). The
 * header trigger opens it; the modal (mounted once in `ClaimFlowLayout`)
 * closes it.
 */
interface ClaimSearchState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useClaimSearchStore = create<ClaimSearchState>((set) => ({
  isOpen: false,
  open: () => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false });
  },
}));
